import { render, staticRenderFns } from "./MailDialog.vue?vue&type=template&id=53bfe963"
import script from "./MailDialog.vue?vue&type=script&lang=js"
export * from "./MailDialog.vue?vue&type=script&lang=js"
import style0 from "./MailDialog.vue?vue&type=style&index=0&id=53bfe963&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports